import all from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import sv from 'i18n-iso-countries/langs/sv.json';

all.registerLocale(en);
all.registerLocale(sv);

const enCountries = all.getNames('en');
const svCountries = all.getNames('sv');

const enColl = new Intl.Collator('en');
const svColl = new Intl.Collator('sv');

const countries = {
  en: Object
    .keys(enCountries)
    .map((code) => ({ code, name: enCountries[code] }))
    .sort((a, b) => enColl.compare(a.name, b.name)),
  sv: Object
    .keys(svCountries)
    .map((code) => ({ code, name: svCountries[code] }))
    .sort((a, b) => svColl.compare(a.name, b.name)),
};

export default countries;
